module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/u5eghR/tc-custom/9781625856449.jpg?1737640607138",
      "alt": "This image is the cover for the book Remarkable Oregon Women, American Heritage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Remarkable Oregon Women, American Heritage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Without the efforts of inspiring, brave women of the past, the progressive and individualistic Oregon we know today might not exist. From native tribes and Oregon Trail pioneers to Victorian suffragists and unlikely politicians, strong female leaders give profound meaning to the state motto, alis volat propriis--she flies with her own wings. Writer and activist Julia Ruuttila fought for the rights of the citizens of Vanport, the largely African American town lost to a disastrous flood in 1948. Others broke stereotypes to serve their communities, like women who helped build ships during World War II and the nation's first female police officer, Portland's own Lola Baldwin. Similarly, Laura Stockton Starcher unseated her husband as mayor of Umatilla. Author Jennifer Chambers tells these and many more stories of progressive, radical women who fought for change within their state.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Chambers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jennifer Chambers writes about strong women with bold stories. Chambers attended the Iowa Writer's Workshop and Duke University and is a freelance writer, editor and part owner of Groundwaters Publishing. She's active in the Body Love Movement as a speaker and an advocate of self-empowerment, speaks across the U.S. about persevering through traumatic brain injury and genetic disorder and teaches writing and self-empowerment workshops to people of all ages.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0